import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { useCart } from "@/context/CartContext";

const PaymentCancel = () => {
  const { t } = useLang();
  const { setOpen } = useCart();

  return (
    <div
      data-testid="payment-cancel-page"
      className="max-w-xl mx-auto px-6 py-32 text-center min-h-[70vh] flex flex-col items-center justify-center"
    >
      <XCircle size={48} strokeWidth={1} className="text-stone-400" />
      <h1 className="font-serif text-4xl tracking-tight text-charcoal mt-8">{t("payment.cancel.title")}</h1>
      <p className="text-stone-500 mt-4">{t("payment.cancel.body")}</p>
      <button
        onClick={() => setOpen(true)}
        data-testid="cancel-cart-cta"
        className="mt-10 bg-charcoal text-white px-10 py-4 text-xs uppercase tracking-[0.2em] hover:bg-stone-800 transition-colors"
      >
        {t("payment.cancel.cta")}
      </button>
      <Link to="/shop" className="mt-6 text-xs uppercase tracking-[0.2em] text-stone-500 hover:text-charcoal border-b border-stone-400 pb-1">
        {t("cart.continue")}
      </Link>
    </div>
  );
};

export default PaymentCancel;
